<div class="add-camera-wizard">
  <!-- Header -->
  <div class="header flex-row space-between-center">
    {{ 'ADD_CAMERA_WIZARD.HEADER.TITLE'|translate }}
    <span class="ui-icon-close c-p" (click)="close()"></span>
  </div>

  <!-- Progress Stepper -->
  <div class="progress-wrapper">
    <div class="progress-steps flex-row">
      <div *ngFor="let step of steps; let i = index" class="step-container flex-row center-center"
        [class.completed]="currentStep > step.step" [class.active]="currentStep === step.step"
        [class.pending]="currentStep < step.step">

        <div class="step-indicator">
          <div class="step-dot"></div>
        </div>

        <div class="step-label" *ngIf="i < steps.length - 1">
          {{ step.label | translate }}
        </div>
        <div class="step-label final" *ngIf="i === steps.length - 1">
          {{ step.label | translate }}
        </div>

        <div class="step-connector" *ngIf="i < steps.length - 1"></div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="body">
    <div class="content-wrapper">
      <!-- Step Title -->

      <!-- Step Components -->
      <div class="wizard-step-container h-100 w-100 flex-row start-center">
        <!-- Step 1: Core Selection -->
        @switch (currentStep) {
        @case (WizardStep.CoreSelection) {
        <div class="flex-col start-start core-selection-wrapper h-100">
          <div class="step-content flex-row start-start">
            <div class="step-title">{{ getStepTitle() | translate}}</div>
          </div>
          <app-wizard-core-selection class="h-100 w-100" [locationId]="data.locationId"
            [locationCore]="data.locationCore" [selectedEdgeIds]="selectedEdgeIds"
            (coreSelected)="onCoreSelected($event)">
          </app-wizard-core-selection>
        </div>
        }
        @case (WizardStep.DetectionMethod) {
        <div class="flex-col start-start detection-selection-wrapper h-100">
          <div class="step-content flex-row start-start">
            <div class="step-title">{{ getStepTitle() | translate }}</div>
          </div>
          <!-- Step 2: Detection Method -->
          <app-wizard-detection-method *ngIf="currentStep === WizardStep.DetectionMethod"
            (detectionMethodSelected)="onDetectionMethodSelected($event)" (back)="onBack()">
          </app-wizard-detection-method>
        </div>
        }
        @case (WizardStep.ScanSelection) {
        <!-- Step 3: Scan & Selection -->
        <app-wizard-scan-selection *ngIf="currentStep === WizardStep.ScanSelection" [edgeId]="selectedEdgeId!"
          class="h-100 w-100" [detectionMethod]="detectionMethod!" [addressRangeData]="addressRangeData"
          (manualConfigChanged)="manualDeviceType = $event.deviceType; manualIpArr = $event.ipArr"
          (csvImportCompleted)="onCsvImportCompleted($event)"
          (camerasSelected)="onCamerasSelected($event)" (back)="onBack()">
        </app-wizard-scan-selection>
        }
        @case (WizardStep.Authentication) {
        <!-- Step 4: Authentication -->
        <app-wizard-authentication class="w-100" [edgeId]="selectedEdgeId!" [locationId]="data.locationId"
          [selectedCameras]="selectedCameras" [manualDiscoveryEnabled]="isManualDiscoveryFlow()"
          [manualDeviceType]="manualDeviceType" [isOnvifFlow]="detectionMethod === DetectionMethod.OnvifSearch"
          [csvImportRows]="csvImportRows"
          [snapshot]="authSnapshot" (cameraDetailsReceived)="onCameraDetailsReceived($event)"
          (selectedCamerasChanged)="onSelectedCamerasChanged($event)"
          (maxSelectableCamerasChange)="onMaxSelectableCamerasChange($event)" (back)="onBack()">
        </app-wizard-authentication>
        }
        @case (WizardStep.Configuration) {
        <!-- Step 5: Configuration -->
        <app-wizard-configuration class="w-100" [selectedCameras]="selectedCamerasForConfig"
          [cameraAuthStates]="cameraAuthStatesForConfig" [edgeId]="selectedEdgeId!" [locationId]="data.locationId"
          (selectedConfigsChanged)="onConfigSelectionChanged($event)" (back)="onBack()">
        </app-wizard-configuration>
        }
        }
      </div>
    </div>
    <!-- Footer -->
  </div>
  <!-- Footer - Normal or Selection Mode -->
  @if (currentStep === WizardStep.Configuration && selectedConfigCameraIds.size > 0) {
  <!-- Configuration Selection Footer -->
  <div class="footer footer-selection">
    <div class="selection-info">
      {{ 'ADD_CAMERA_WIZARD.FOOTER.SELECTED_TO_CONFIGURE' | translate:{selected: selectedConfigCameraIds.size, total:
      getCamerasToAddCount()} }}
    </div>
    <div class="selection-actions flex-row start-center gap-8">
      <ui-button type="primary" [text]="'ADD_CAMERA_WIZARD.FOOTER.CONFIGURE_SELECTED'|translate"
        (clickAction)="openConfigureDialog()"></ui-button>
      <div class="flex-row center-center">
        <span class="ui-icon-close clear-selection" (click)="clearConfigSelection()"></span>
      </div>
    </div>
  </div>
  } @else {
  <!-- Normal Footer -->
  <div class="footer flex-row space-between-center w-100">
    <div class="footer-info flex-row start-center gap-8">
      @if (currentStep === WizardStep.Configuration && getCamerasToAddCount() > 0) {
      <span class="ui-icon-grouped-cameras"></span>
      <span class="cameras-count">{{ 'ADD_CAMERA_WIZARD.FOOTER.CAMERAS_TO_BE_ADDED' | translate:{count:
        getCamerasToAddCount()} }}</span>
      } @else if (currentStep === WizardStep.Authentication && maxSelectableCameras !== -1) {
      <span class="cameras-count">{{ selectedAuthCameraIds.size }} out of {{ maxSelectableCameras }} available
        slots</span>
      }
    </div>
    <div class="flex-row start-center gap-8">
      <ui-button type="secondary" [text]="'COMMON.BACK'|translate" (clickAction)="onBack()"
        [disabled]="!canGoBack() || isCreating"></ui-button>
      <ui-button type="primary" [text]="getNextButtonText() | translate:getNextButtonTextParams()"
        (clickAction)="onNext()" [disabled]="!canGoNext()" [loading]="isCreating"></ui-button>
    </div>
  </div>
  }
</div>